import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import SiteFooter from "./SiteFooter";
import SiteHeader from "./SiteHeader";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import OverLayComponent from "../components/OverLayComponent";
import {getSeoAnalytics} from "../services/HomePageService";

import { Helmet } from "react-helmet";
import {
  deleteCart,
  getCartItems,
  modifyCart,
  updateCart,
} from "../redux/actions/cartActions";
import {
  getSeoData,
  updateSeoData
} from "../redux/actions/seoActions";

const SiteLayout = (props) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getCartItems());
    getSeoDatas();
  }, []);
  useEffect(() => {
    dispatch(getSeoData());
  }, []);
  const seoData = useSelector((state) => state.seoReducer.result) || {};
  const myCartData = useSelector((state) => state.cartReducer.result) || {};
  const [seoDatas, setSeoDatas] = useState({ loader: true, data: [] });
  const { cartItems } = myCartData;
  const getSeoDatas = async () => {
    const setSeos = await getSeoAnalytics();
    if (setSeos) {
      setSeoDatas({

        loader: false,
        data: setSeos,
      });
    }
  };
  // const AddHelmet = ({ data }) => {

  //   return (
  //     <>
  //       {/* <Helmet> */}
  //       {data &&
  //         data.map(({ analytics_code ,code_position}) => (
  //           <>
  
  //             {code_position == 1 ? (
  //               // <Helmet> 
  //                 {analytics_code}
  //               // </Helmet>
  //               // <div dangerouslySetInnerHTML={{ __html: analytics_code }} />
  //             ) : ("")
  //             }
  
  //           </>
  //         ))}
  //       {/* </Helmet> */}
  //     </>
  
  //   );
  // };
  // dispatch(cartItems(actionResponse));
  return (

    <>
   
        {/* <Helmet>
          <meta charSet="utf-8" />
          <meta name="description" content={seoData.meta_description} />
          <meta name="keywords" content={ seoData.meta_keywords} />
          <meta property="og:title" content={ seoData.og_title} />
          <meta property="og:description" content={seoData.og_image} />
          <meta property="og:url" content={ seoData.og_image} />
          <meta property="og:image" content={seoData.og_image} />
          <meta property="twitter:card" content={seoData.twitter_card} />
          <meta property="twitter:title" content={ seoData.twitter_title} />
          <meta property="twitter:description" content={seoData.twitter_description} />
          <meta property="twitter:url" content={ seoData.twitter_url} />
          <meta property="twitter:image" content={seoData.twitter_image} />
          <title>{seoData.meta_title}</title>
          <link rel="canonical" href={seoData.canonical} />
        </Helmet> */}
    {/* <AddHelmet data={seoDatas.data} /> */}
      <ToastContainer
        position='bottom-right'
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme='colored'
      />
      <OverLayComponent />
      <SiteHeader />
      {props.children}
      <SiteFooter />

      
    </>
  );
};

export default SiteLayout;
